import script from "./ServicesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesCard.vue?vue&type=script&setup=true&lang=js"

import "./ServicesCard.vue?vue&type=style&index=0&id=66615b2a&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66615b2a"]])

export default __exports__